import { useContext, useState, useRef } from "react";
import { Card, CardBody, Col, Collapse, Row, Spinner } from "reactstrap";
import ImageComponent from "../common/ImageComponent";
import { _imagesURL, adminBaseURL } from "../../constants/API";
import Like from "../../assets/images/icon/like.png";
import Liked from "../../assets/images/icon/liked.png";
import Reshare from "../../assets/images/icons/repost.svg";
import ReshareActive from "../../assets/images/icons/repost-active.svg";
import Save from "../../assets/images/icons/save.svg";
import Saved from "../../assets/images/icons/saved.svg";
import Comment from "../../assets/images/icon/comment.png";
import Avatar from "../../assets/images/icon/placeholder_Awatar.png";
import { Language, PostDetailContext } from "../../App";
import { RiEditLine } from "react-icons/ri";
import { authorize } from "../../shared/authorize";
import { toast } from "react-toastify";
import axios from "axios";
import { UnixToRelative } from "../notification/Notification";
import RepostUserModal from "./RepostUserModal";
import { useCallback } from "react";
import { useEffect } from "react";
import usePollRemainingTime from "../../hooks/usePollRemainingTime";
import { useQueryClient } from "react-query";
import MixpanelManager from "../../constants/MixpanelManager";
import { MixpanelEvents } from "../../constants/MixpanelEvents";
import { createPortal } from "react-dom";
const PostFooter = ({
  likes_count,
  setPostId,
  original_id,
  handleLikeUsers,
  like_users_images,
  handleLike,
  isLike,
  handleGetComments,
  comments_count,
  handleRepost,
  isShare,
  isSave,
  handleSave,
  type,
  pollData,
  shares_count,
  value,
}) => {
  const { updatePostDetail,isOpen:_isOpen } = useContext(PostDetailContext);
  const { lang } = useContext(Language);
  const queryClient = useQueryClient();
  const userData = localStorage.getItem("SignupData");
  const user = userData ? JSON.parse(userData) : null;
  const user_id = user?.data?.id;
  const [isOpen, setIsOpen] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const collapseRef = useRef(null); 

  const toggleModal = useCallback((id) => {
    setModalOpen((prev) => !prev);
  }, []);
  const repostButtonRef = useRef(null); // Reference for the repost button

  const toggleCollapse = () => setIsOpen(!isOpen);

  const getRepostButtonPosition = () => {
    if (repostButtonRef.current) {
      const rect = repostButtonRef.current.getBoundingClientRect();
      return { top: rect.bottom + window.scrollY, left: rect.left };
    }
    return { top: 0, left: 0 };
  };
  const fetchFeeds = () => {
    queryClient.invalidateQueries('feedData');
  };
  const handleRepostClick = () => {
    if (type !== "poll") {
      // When type is not "poll"
      if (!isOwner) {
        handleRepost(original_id);
      } else {
        // Handle when type is not "poll" and isOwner is true
        setModalOpen(true);
      }
      fetchFeeds()
    } else {
      // When type is "poll"
      if (isOwner) {

        setModalOpen(true); // or any other logic you'd like to add for this case
      } else {
        // Handle when type is "poll" and isOwner is false
        if (!isShare) {
          toggleCollapse(); // Toggle collapse when isShare is false
        } else {
          handleRepost(original_id); // Repost when isShare is true
        }
      }
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (collapseRef.current && !collapseRef.current.contains(event.target)) {
        setIsOpen(false); // Close the collapse if clicked outside
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const self_like_image = user?.data?.image
  const isOwner = value?.user?.id === user_id
  const repostTitle = isOwner
    ? `${shares_count} ${lang?.repost}`
    : `${isShare ? lang?.reposted : lang?.repost}`;


  return (
    <>
      <div>
        {likes_count > 0 && (
          <>
            <Row className="ps-4 pe-3 py-2">
              <Col
                className="d-flex cursor"
                onClick={() => {
                    setPostId(original_id);
                    handleLikeUsers(original_id);
                    MixpanelManager.track(MixpanelEvents.listOfLikes, {
                      post_id: original_id,
                      user_id: user_id
                    });
                }}
              >
                {like_users_images && like_users_images.length > 0 ? (
                  like_users_images.map((data, index) => (
                    <div
                      key={`new-${index}`}
                      className="bg-white rounded-circle"
                      style={{
                        marginLeft: "-10px",
                        padding: "1px",
                        border: "1px solid rgba(29, 193, 221, 1)",
                      }}
                    >
                      <div style={{height:"25px"}}>
                      <ImageComponent
                        src={data && data !== ".." ? _imagesURL + data : Avatar}
                        img_width={25}
                        img_height={25}
                        compClassName="rounded-circle"
                      />
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className="bg-white rounded-circle"
                    style={{
                      marginLeft: "-10px",
                      padding: "1px",
                      border: "1px solid rgba(29, 193, 221, 1)",
                    }}
                  >
                    <div style={{height:"25px"}}>
                    <ImageComponent
                      src={self_like_image ? _imagesURL + self_like_image : Avatar}
                      img_width={25}
                      img_height={25}
                      compClassName="rounded-circle"
                    />
                    </div>
                  </div>
                )}
                <p className="ps-2 fs-14 fs-md-12 roboto-medium mb-0 align-self-center text-ellips-162px hover-blue">
                  {likes_count > 3
                    ? `& ${likes_count - 3} ${lang?.other_have_liked}`
                    : `${lang?.have_liked}`}
                </p>
              </Col>
            </Row>
            <hr className="m-0" />
          </>
        )}
        <div className="d-flex px-lg-3 px-md-3 px-sm-2 px-2 py-2 mt-2 justify-content-between align-items-center">
          <div className="d-flex gap-lg-4 gap-md-3 gap-sm-3 gap-3">
            <div
              className="d-flex gap-1 cursor"
              onClick={() => {
                handleLike(original_id);
                MixpanelManager.track(MixpanelEvents.likePost, {
                  post_id: original_id,
                  user_id: user_id,
                  is_liked: !isLike
                });
              }}
            >
              <div>
                <img width={18} height={18} src={isLike ? Liked : Like} alt="..." />
              </div>
              <div className="align-self-end hover-blue">
                <p className="mb-0 fw-bold fs-14 fs-md-12">
                  {likes_count > 0 && likes_count}{" "}
                  {likes_count > 1 ? lang?.likes : lang?.like}
                </p>
              </div>
            </div>
            <div
              className="d-flex gap-1 cursor justify-content-center"
              onClick={() => {
                setPostId(original_id);
                handleGetComments(original_id);
                updatePostDetail(value);
                MixpanelManager.track(MixpanelEvents.addComment, {
                  post_id: original_id,
                  user_id: user_id
                });
              }}
            >
              <div>
                <img width={18} height={18} src={Comment} alt="..." />
              </div>
              <div className="align-self-end hover-blue">
                <p className="mb-0 fw-bold fs-14 fs-md-12">
                  {comments_count > 0 ? comments_count : ""} {lang?.comments}
                </p>
              </div>
            </div>
            <div
              ref={repostButtonRef}
              className="d-flex gap-1 cursor"
              onClick={() => {
                handleRepostClick();
                MixpanelManager.track(MixpanelEvents.repost, {
                  post_id: original_id,
                  user_id: user_id,
                  is_reposted: !isShare
                });
              }}
            >
              <div>
                <img
                  src={isShare ? ReshareActive : Reshare}
                  width={18}
                  height={18}
                  alt="..."
                />
              </div>
              <div className="align-self-end hover-blue">
                <p
                  className={`mb-0 fw-bold fs-14 fs-md-12 ${isShare && "text-blue"
                    }`}
                >
                  {repostTitle}
                  {/* {shares_count} {isShare ? lang?.reposted : lang?.repost} */}
                </p>
              </div>
            </div>
            <div
              className="d-flex gap-1 cursor"
              onClick={() => {
                handleSave(original_id);
                MixpanelManager.track(MixpanelEvents.savePost, {
                  post_id: original_id,
                  user_id: user_id,
                  is_saved: !isSave
                });
              }}
            >
              <div>
                <img
                  className="w-lg-23px"
                  title={
                    isSave ? lang?.save_description : lang?.unsave_description
                  }
                  src={isSave ? Saved : Save}
                  width={18}
                  height={18}
                  alt="..."
                />
              </div>
              <div className="align-self-end hover-blue">
                <p
                  className={`mb-0 fw-bold fs-14 fs-md-12 ${isSave && "text-blue"
                    }`}
                >
                  {isSave ? lang?.saved : lang?.save}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div ref={collapseRef}>
      <Collapse isOpen={isOpen}   >
      <Card
        style={{
          position: 'absolute',
          top: `${getRepostButtonPosition().top + 5}px`,
          left: `${getRepostButtonPosition().left}px`,
          zIndex: 1000,
          width: '22%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
        }}
      >
          <RepostCard
            repost={handleRepost}
            original_id={original_id}
            toggleCollapse={toggleCollapse}
            pollData={pollData}
          />

        </Card>
      </Collapse>
      </div>
      {modalOpen && <RepostUserModal toggleModal={toggleModal} modal={modalOpen} postId={original_id} />}

    </>
  );
};

export default PostFooter;
export const RepostCard = ({ repost, original_id, toggleCollapse, pollData }) => {
  const {lang} = useContext(Language);
  const [isPopupOpen, setPopupOpen] = useState(false);

  const handleOpenPopup = (e) => {
    e.stopPropagation(); // Prevent click from bubbling up to PostDropdown
    e.preventDefault()
    setPopupOpen(true);}
  const handleClosePopup = () => setPopupOpen(false);
  const handlePost = () => {
    setPopupOpen(false);
  };
  return (
    <>
        <CardBody
          style={{
            display: "flex",
            flexDirection: "column", // Stack items vertically
            gap: "3px", // Add space between elements
            width: "100%", // Allow card body to take full width
            cursor: "pointer", // Change cursor to pointer
          }}
        >
          {/* First section: Icon + Text */}
          <div className="hover-effect" onClick={handleOpenPopup}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <RiEditLine size={16} />
              <p className="fw-bold" style={{ margin: 0, flex: 1 }} >{lang.repost_with_your_thoughts}</p>
            </div>
            <small className="text-muted" style={{ marginLeft: "26px" }}>
              {lang.repost_this_poll_with_your_thoughts}
            </small>
          </div>

          <div className="hover-effect" onClick={() => {
            repost(original_id);
            toggleCollapse()
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img src={Reshare} alt="Repost Icon" width={16} height={16} />
              <p className="fw-bold" style={{ margin: 0, flex: 1 }} >{lang.repost}</p>
            </div>
            <small className="text-muted" style={{ marginLeft: "26px" }}>
              {lang.repost_this_poll_without_your_thoughts}
            </small>
          </div>
        </CardBody>
      <RepostPollPopup
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        onPost={handlePost}
        pollData={pollData}
        toggleRepostCard={toggleCollapse}
      />
    </>
  );
};
export const RepostPollPopup = ({ isOpen, onClose, onPost, pollData, toggleRepostCard }) => {
  const { lang } = useContext(Language);
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const [caption, setCaption] = useState("");
  const remainingTime = usePollRemainingTime(pollData?.time, pollData?.duration);

  if (!isOpen) return null;

  const repostWithThoughts = async () => {
    if (caption === "") {
      toast.error(lang.caption_is_required);
      return;
    }
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${adminBaseURL}user/post/repost/${pollData?.original_id}`,
        { caption },
        authorize()
      );
      if (response.data.status) {
        setIsLoading(false);
        setCaption("");
        onClose();
        queryClient.invalidateQueries("feedData");
        toggleRepostCard();
        onPost();
        return response.data;
      } else {
        toast.error(response.data.message || "Something went wrong.");
        setIsLoading(false);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while reposting.");
      console.error("Error reposting:", error);
      setIsLoading(false);
    }
  };

  const handlePopupClick = (e) => {
    e.stopPropagation(); // Prevent clicks inside the popup from bubbling up
  };

  const modalContent = (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 10000, // Higher zIndex to outrank most elements
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "auto", // Ensure scrolling if content overflows
      }}
      onClick={onClose} // Close only when clicking outside
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        onClick={handlePopupClick} // Stop propagation for clicks inside the popup
      >
        <div
          className="modal-content"
          style={{ zIndex: 10001 }} // One higher than backdrop
        >
          <div className="modal-header border-0">
            <h5 className="modal-title">{lang.repost_poll}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            />
          </div>
          <div className="modal-body">
            <textarea
              className="form-control mb-3"
              rows="3"
              placeholder={lang.please_enter_your_thoughts}
              style={{ resize: "none", backgroundColor: "#f7f7f7" }}
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
              onClick={handlePopupClick} // Ensure clicks in textarea don’t dismiss
            />
            <div className="p-3 border rounded">
              <div className="d-flex align-items-center mb-3">
                <img
                  src={pollData?.user?.image ? _imagesURL + pollData?.user?.image : Avatar}
                  alt="User"
                  className="rounded-circle me-2"
                  width="30px"
                  height="30px"
                />
                <div>
                  <strong>{pollData?.user?.name}</strong>
                  <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                    {lang.posted} <UnixToRelative unixTimestamp={pollData?.time} />
                  </p>
                </div>
              </div>
              <p>{pollData?.title}</p>
              <div className="pt-3">
                {pollData?.media[0] && (
                  <div
                    className="mt-3 d-flex justify-content-center align-items-center"
                    style={{ height: "300px" }}
                  >
                    <div className="image-preview mb-3">
                      <img
                        src={pollData?.media[0] ? _imagesURL + pollData?.media[0] : Avatar}
                        alt="Poll Preview"
                        className="img-fluid rounded"
                        style={{ maxWidth: "100%", height: "300px" }}
                      />
                    </div>
                  </div>
                )}
                <div className="mt-3">
                  {[pollData?.option_1, pollData?.option_2, pollData?.option_3, pollData?.option_4]
                    .filter((data) => data !== "" && data !== null)
                    .map((option, index) => (
                      <div className="custom-box mb-2 cursor" key={index}>
                        {option}
                      </div>
                    ))}
                </div>
              </div>
              <div className="d-flex justify-content-between mt-3">
                <span className="text-muted">
                  {pollData.votes_count} {lang.votes}
                </span>
                <span className="text-muted">{remainingTime}</span>
              </div>
            </div>
          </div>
          <div className="modal-footer border-0">
            <button
              type="button"
              className="btn px-3"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              style={{ backgroundColor: "white", border: "1px solid #848798", color: "#848798" }}
            >
              {lang.cancel}
            </button>
            <button
              type="button"
              className="btn px-4"
              onClick={(e) => {
                e.stopPropagation();
                repostWithThoughts();
              }}
              disabled={isLoading}
              style={{ backgroundColor: "#1DC1DD", color: "white" }}
            >
              {isLoading ? <Spinner /> : lang.post}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

